import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    InValue:"",
}

const InstSlice = createSlice({
    name: "InstSlice",
    initialState,

    reducers: {
        SelecTInstData(state, action) {
            return {
                    InValue:action.payload.InValue,
            };
        }
    }
})
export const { SelecTInstData } = InstSlice.actions;
export default InstSlice.reducer;